export type UsersFiltersMessages = {
  emailLabel: string;
  nameLabel: string;
  statusLabel: string;
  statusActiveLabel: string;
  statusWaitingForConfirmationLabel: string;
  statusInactiveLabel: string;
  clearFilterButton: string;
  filterButton: string;
};

export const USERS_FILTERS_MESSAGES: UsersFiltersMessages = {
  emailLabel: "Email",
  nameLabel: "Nome",
  statusLabel: "Status",
  statusActiveLabel: "Ativo",
  statusWaitingForConfirmationLabel: "Aguardando Confirmação",
  statusInactiveLabel: "Inativo",
  clearFilterButton: "Limpar filtros",
  filterButton: "Filtrar",
};
